import type { PortalWording } from "@shared-core/domain/portal-sign-in/types";
import { Button } from "../primitives/button";
import { Card } from "../primitives/card";
import { SignInFrame } from "./SignInFrame";

export interface PasskeyOfferScreenProps {
  wording: PortalWording;
  busy?: boolean;
  onSave(): void;
  onSkip(): void;
}

/** Offered once, right after a way that isn't Microsoft: save a passkey on this device. */
export function PasskeyOfferScreen({
  wording,
  busy = false,
  onSave,
  onSkip,
}: PasskeyOfferScreenProps) {
  return (
    <SignInFrame eyebrow={wording.brand} title="Sign in faster next time?">
      <Card className="gap-3 p-5">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          className="size-[18px]"
          aria-hidden="true"
        >
          <circle cx="9" cy="8" r="4" />
          <path d="M3 20c0-3.3 2.7-6 6-6" />
          <circle cx="17" cy="15" r="2.4" />
          <path d="M17 17.4V22m0-2h2" />
        </svg>
        <p className="text-sm">
          Save a passkey on this device. Next time, you&apos;ll sign in with
          Face ID, a fingerprint or your device PIN, with no code to wait for.
        </p>
        <Button
          className="h-10 w-full font-semibold"
          disabled={busy}
          onClick={onSave}
        >
          Save a passkey
        </Button>
        <Button
          variant="ghost"
          className="h-10 w-full font-medium text-muted-foreground"
          onClick={onSkip}
        >
          Not now
        </Button>
      </Card>
    </SignInFrame>
  );
}
